/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} External_Apis_Space_Field_Credential_HintInputs */



/**
* | output |
* | --- |
* | "Stored encrypted; never shown to users or the model." |
*
* @param {External_Apis_Space_Field_Credential_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const external_apis_space_field_credential_hint = /** @type {((inputs?: External_Apis_Space_Field_Credential_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<External_Apis_Space_Field_Credential_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wird verschlüsselt gespeichert; niemals für Benutzer oder das Modell sichtbar.")
	return /** @type {LocalizedString} */ ("Stored encrypted; never shown to users or the model.")
});